import { render, staticRenderFns } from "./ModalDownloadAlbumChoice.vue?vue&type=template&id=648fe0bd"
import script from "./ModalDownloadAlbumChoice.vue?vue&type=script&lang=js"
export * from "./ModalDownloadAlbumChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports